// tslint:disable: completed-docs
// Container
export const APP = 'HARDWARE_DETAIL';

export const CONTAINER_MAIN = 'HARDWARE_DETAIL';
export const CONTAINER_OPTIONS = 'OPTIONS';
export const CONTAINER_TARIFF = 'TARIFF';
export const CONTAINER_STORAGE = 'STORAGE';
export const CONTAINER_TRADEIN = 'TRADEIN';
